import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "streamline:shopping-catergories-ring-money-diamond-payment-wealth-finance-ring-accessories" }, [
      _createElementVNode("g", { id: "Group" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M19.9993 36.2798C25.9791 36.2798 30.8267 31.4322 30.8267 25.4524C30.8267 19.4726 25.9791 14.625 19.9993 14.625C14.0195 14.625 9.17188 19.4726 9.17188 25.4524C9.17188 31.4322 14.0195 36.2798 19.9993 36.2798Z",
          stroke: "#401D42",
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          id: "Vector_2",
          d: "M23.6126 5L26.0187 7.40609L20.0035 14.6244L13.9883 7.40609L16.3944 5L20.0035 9.5L23.6126 5Z",
          stroke: "#401D42",
          "stroke-width": "1.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }